import styled from 'styled-components';

export const SelectPlanStyles = styled.section`
  margin: -225px auto 24px;
  padding: 0 16px;
  max-width: 540px;

  @media (max-width: 480px) {
    margin: -125px auto 24px;
  }

  @media (max-width: 375px) {
    margin: -100px auto 24px;
  }
`;

export const SelectPlanButtonStyles = styled.button`
  display: block;
  padding: 11px 60px;
  color: #fff;
  margin: 16px auto 8px;
  width: 100%;
  font-size: 17px;
  line-height: 22px;
  font-weight: 600;
  border: 0;
  border-radius: 8px;
  background: linear-gradient(272.88deg, #686de0 4.95%, #4834d4 93.62%);
`;
